export const COPY_TEXT = 'COPY_TEXT'
export const EXECUTE_COPY_AGAIN = 'EXECUTE_COPY_AGAIN'